var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgGroup1Ic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 436,
    height: 421,
    viewBox: "0 0 436 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 17,
    y: 103.945,
    width: 117.332,
    height: 412.949,
    rx: 58.6661,
    transform: "rotate(-61.3976 17 103.945)",
    fill: "url(#paint0_linear_1043_89161)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    y: 287.014,
    width: 117.332,
    height: 278.853,
    rx: 58.6661,
    transform: "rotate(-61.3976 0 287.014)",
    fill: "url(#paint1_linear_1043_89161)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_89161",
    x1: 75.6662,
    y1: 103.945,
    x2: 75.6662,
    y2: 516.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EEAD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1043_89161",
    x1: 58.6662,
    y1: 287.014,
    x2: 58.6662,
    y2: 565.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EEAD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGroup1Ic);
export default __webpack_public_path__ + "static/media/bgGroup1_ic.8fe0fd52.svg";
export { ForwardRef as ReactComponent };